var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticClass:"logo",staticStyle:{"z-index":"100"},attrs:{"transition":"none","src":"assets/logo_transparent.png","width":_vm.width,"height":"auto","contain":""},on:{"click":_vm.navigate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }